import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { useAuth } from "../../store/auth";
import { createPortal } from "react-dom";
// import "./SignupPopup.css";
import LoginPopup from "./LoginPopup";


const SignupPopup = ({ handleClose }) => {
  const [showLogin, setShowLogin] = useState(false);
  const navigate = useNavigate();
  const { storeTokenInLS } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [signupSuccess, setSignupSuccess] = useState(false);

  async function submit(e) {
    e.preventDefault();

    try {
      const resp = await axios.post("http://localhost:5000/api/signup", {
        name,
        email,
        phone,
        password
      });

      // console.log(resp.data);
      const resp_data = resp.data;
      console.log("data from server", resp_data.message);
      //stored the token in localhost
      storeTokenInLS(resp_data.token);
      setName("");
      setEmail("");
      setPhone("");
      setPassword("");
      setSignupSuccess(true);
      navigate('/');
    } catch (e) {
      console.log(e);
      alert("Something went wrong");
    }
  }
   // Close the popup if signup was successful
   useEffect(() => {
    if (signupSuccess) {
      handleClose();
    }
  }, [signupSuccess, handleClose]);


 // Use createPortal to render the component at the root level
 return createPortal(
    <>
    <div className="popup-overlay"></div>
    <div className="popup">
      <div className="popup-inner">
      <button className="close-btn" onClick={handleClose}>Close</button>
        <h2>Signup</h2>
        <form onSubmit={submit}>
          <input type="text" placeholder="Full Name" value={name} onChange={(e) => setName(e.target.value)} required />
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <input type="number" placeholder="Phone" value={phone} onChange={(e) => setPhone(e.target.value)} required />
          <input type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          <button type="submit">Sign Up</button>
        </form>
        {showLogin ? (
            <LoginPopup handleClose={() => setShowLogin(false)} />
          ) : (
            <p>
              Already have an account?
              <span onClick={() => setShowLogin(true)}>Login</span>
            </p>
          )}

      </div>
    </div>
    </>,
     document.getElementById("popup-root")
  );
};

export default SignupPopup;